module.exports = __webpack_public_path__ + "img/曲靖市第一人民医院.bead6d93.png";